// تازه‌سازی خودکار نشست: وقتی توکن دسترسی (۶ ساعته) منقضی شده باشد و سرور ۴۰۱ بدهد،
// یک بار با کوکی refresh_token توکن جدید می‌گیریم و همان درخواست را تکرار می‌کنیم.

const originalFetch = window.fetch.bind(window);
let refreshing = null;

const AUTH_PATHS = /\/auth\/(login|register|refresh|logout|send|verify|forgot)/;

const getCsrf = () => {
  const m = document.cookie.match(/(?:^|;\s*)csrftoken=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : null;
};

window.fetch = async (input, init) => {
  const response = await originalFetch(input, init);

  if (
    response.status !== 401 ||
    typeof input !== 'string' ||
    !input.includes('/api/') ||
    AUTH_PATHS.test(input) ||
    !localStorage.getItem('user')
  ) {
    return response;
  }

  if (!refreshing) {
    const base = input.split('/api/')[0];
    const headers = { 'Content-Type': 'application/json' };
    const csrf = getCsrf();
    if (csrf) headers['X-CSRFToken'] = csrf;
    refreshing = originalFetch(`${base}/api/auth/refresh/`, {
      method: 'POST',
      credentials: 'include',
      headers,
    }).finally(() => { refreshing = null; });
  }

  const refreshResponse = await refreshing;
  if (refreshResponse.ok) {
    return originalFetch(input, init); // تکرار درخواست اصلی، یک بار
  }

  // نشست کاملاً منقضی شده — کاربر باید دوباره وارد شود
  localStorage.removeItem('user');
  window.location.reload();
  return response;
};